import Vue from 'vue';
import VueI18n from 'vue-i18n';

import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

// 引入各个语言配置文件
import zh from '@/assets/languages/zh.js';
import en from '@/assets/languages/en.js';

Vue.use(VueI18n);

// 创建vue-i18n实例
const i18n = new VueI18n({
    //设置默认语言
    locale: localStorage.getItem('lang') || 'zh',
    // locale: localStorage.getItem('lang') || 'zh',
    // 添加多语言（每个语言标识对应一个语言文件）
    messages: {
        zh: {
            ...zh, ...zhLocale
        },
        en: {
            ...en, ...enLocale
        }
    }
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js